import React, { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import TitleBar from '../../../components/TitleBar';
import { setPwInfo } from '../slice';

import { Link } from "react-router-dom";

import styles from './styles.module.css'
import urls from '../../Viewer/urls';

import { changePassword } from '../slice';

import Alert from "react-bootstrap/Alert"
import BaseButton from '../../../components/BaseButton';
import BottomBar from '../../../components/BottomBar';
import { homeUrl } from '../../Home/urls';

const ChangePassword = () => {

  const dispatch = useDispatch();
  const changePasswordResult = useSelector((state) => state.changePassword);

  const [oldPw, setOldPw] = useState('');
  const [newPw, setNewPw] = useState('');
  const [newConfirmPw, setNewConfirmPw] = useState('');

  const forbidden = useSelector((state) => state.login.forbidden);

  // // let forbiddenMessage = null;
  // console.log(forbidden)
  // if (!forbidden) {
  //   // forbiddenMessage = (
  //   //   <div className={styles.item} role="alert">
  //       alert('まだログインしていないか、セッションが切れました。ログインし直してください。')
  //       window.location = homeUrl();
  //     // </div>
  //   // )
  // }

  let message = null;
  if (changePasswordResult.success) {
    message = (
      <Alert variant="info">{changePasswordResult.message}</Alert>
    );
  } else {
    if (changePasswordResult.message) {
      message = (
        <Alert variant='danger'>{changePasswordResult.message}</Alert>
      )
    }
  }

  return (
    <>
      <TitleBar />
      {message}
      <div className={styles.title}>
        パスワード変更
        <br />
        <div className='en'>
          Change Password
        </div>
      </div>
      <div className={styles.form}>
        <div>
          <ul>
            <li>
              パスワードに使用できるのは英数字のみです。
              <br />
              <div className='en'>Only alphanumeric characters are allowed in the password.</div>
            </li>
            <li>
              パスワードは最低 8 文字以上必要です。
              <div className='en'>The password must be at least 8 characters long.</div>
            </li>
            <li>
              半角英小文字、大文字、数字をそれぞれ1文字以上含む文字列を設定してください。
              <div className='en'>The password must contain at least one lowercase, one uppercase, and one numeric character.</div>
            </li>
          </ul>
        </div>
        <div className={styles.item}>
          <div className={styles.labels}>
            <label htmlFor='oldPw'>現在のパスワード</label>
            <label htmlFor='oldPw'>Current Password</label>
          </div>
          <input id='oldPw' type='password' className='form-control'
            onChange={(e) => setOldPw(e.target.value)} />
        </div>
        <div className={styles.item}>
          <div className={styles.labels}>
            <label htmlFor='newPw'>新しいパスワード</label>
            <label htmlFor='newPw'>New Password</label>
          </div>
          <input id='newPw' type='password' className='form-control'
            onChange={(e) => setNewPw(e.target.value)} />
        </div>
        <div className={styles.item}>
          <div className={styles.labels}>
            <label htmlFor='newPwConfirm'>新しいパスワード（確認）</label>
            <label htmlFor='newPwConfirm'>New Password (Confirm)</label>
          </div>
          <input id='newPwConfirm' type='password' className='form-control'
            onChange={(e) => setNewConfirmPw(e.target.value)} />
        </div>
        <div className={styles.item}>
          <BaseButton onClick={() => {
            dispatch(changePassword(oldPw, newPw, newConfirmPw))
          }}>
            パスワードを変更する<br />
            Change Password
          </BaseButton>
        </div>
      </div>
      <BottomBar />
    </>
  );
};

export default ChangePassword;